import * as React from 'react'

import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router'

import {
  SideMenuLayoutMenuItem,
  useSecondaryMenu,
} from '@enechain/ecloud-designsystem'
import {
  EnecSimulationSolid,
  FaChartColumnRegular,
  FaSquareListRegular,
} from '@enechain/ecloud-icons'

import { useGetMe } from '~/pages/hooks/useGetMe'
import {
  PATH_CONTRACT_LIST,
  PATH_HOME,
  PATH_MARGIN_REPORT,
  PATH_SIMULATION,
} from '~/routes/routePaths'

export const MainLayoutTopMenu: React.FC = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { t } = useTranslation(['page', 'domain'])

  const { clearSecondaryMenu } = useSecondaryMenu()
  const { optionCategory } = useGetMe()

  const showMarginReport = optionCategory === 'OPTION_1'

  return (
    <>
      {showMarginReport && (
        <SideMenuLayoutMenuItem
          IconLeft={FaChartColumnRegular}
          isActive={pathname === PATH_MARGIN_REPORT.path}
          label={t(PATH_MARGIN_REPORT.name)}
          onClick={(): void => {
            navigate(PATH_MARGIN_REPORT.path)
            clearSecondaryMenu()
          }}
        />
      )}
      <SideMenuLayoutMenuItem
        IconLeft={EnecSimulationSolid}
        isActive={
          pathname === PATH_HOME.path || pathname === PATH_SIMULATION.path
        }
        label={t(PATH_HOME.name)}
        onClick={(): void => {
          navigate(PATH_HOME.path)
          clearSecondaryMenu()
        }}
      />
      <SideMenuLayoutMenuItem
        IconLeft={FaSquareListRegular}
        isActive={pathname === PATH_CONTRACT_LIST.path}
        label={t(PATH_CONTRACT_LIST.name)}
        onClick={(): void => {
          navigate(PATH_CONTRACT_LIST.path)
          clearSecondaryMenu()
        }}
      />
    </>
  )
}
